import { useEffect, useState } from 'react';
import { useApiContext } from '@/contexts/apiContext';
import ProgressIndicator from '../progressIndicator';
import VideoViewer from './videoViewer';

type Props = {
  dataSourceDefId: string;
  dataSourceInstanceId: string;
  dataSourceItemId: string;
  filename: string;
  mimeType: string;
  maxHeight: number;
  showLabel?: boolean;
  eventId?: string;
  dataSourceInstance?: any;
  parentItemName?: string;
  pipelineInstanceId?: string;
};

const VideoDataSourceViewer = ({
  dataSourceDefId,
  dataSourceInstanceId,
  dataSourceItemId,
  filename,
  mimeType,
  maxHeight,
  showLabel,
  eventId,
  dataSourceInstance,
  parentItemName,
  pipelineInstanceId,
}: Props) => {
  const apiContext = useApiContext();

  const [videoContent, setVideoContent] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    const downloadVideo = async () => {
      setError(null);
      try {
        setLoading(true);

        const meta = dataSourceInstance?.dataSourceDef?.metadata || {};
        const getFromSourceDirectly =
          meta.hasParentChildItems === true && meta.publishParentItemEvents === false && !parentItemName;

        if (getFromSourceDirectly) {
          const data = await apiContext.getDataSourceItemContentDirectFromSource(
            dataSourceDefId,
            dataSourceInstanceId,
            filename || dataSourceItemId,
            false,
          );
          const blob = new Blob([data], { type: mimeType });
          const objectUrl = URL.createObjectURL(blob);
          setVideoContent(objectUrl);
          return;
        }

        const { content } = await apiContext.getDataSourceInstanceItem(
          dataSourceDefId,
          dataSourceInstanceId,
          dataSourceItemId,
          false,
          eventId,
          pipelineInstanceId,
        );
        const decoder = new TextDecoder('utf-8');
        let base64String = '';
        try {
          const textContent = JSON.parse(decoder.decode(content));
          if (textContent.type && textContent.content) {
            if (textContent.type === 'Base64Encoded') {
              base64String = textContent.content;
            } else {
              base64String = btoa(textContent.content);
            }
          } else {
            throw new Error('Not document JSON');
          }
        } catch (e) {
          base64String = btoa(
            new Uint8Array(content).reduce((data, byte) => {
              return data + String.fromCharCode(byte);
            }, ''),
          );
        }
        setVideoContent(`data:${mimeType};base64,${base64String}`);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (dataSourceDefId && dataSourceInstanceId && dataSourceItemId) {
      downloadVideo();
    }
  }, [dataSourceDefId, dataSourceInstanceId, dataSourceItemId, eventId]);

  if (loading) {
    return <ProgressIndicator />;
  }
  return <VideoViewer videoDataUrl={videoContent} showLabel={showLabel} label={filename} error={error} maxHeight={0} />;
};

export default VideoDataSourceViewer;
